import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaCheck } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import EmailNotificationTextModal from "../../../../components/email-notification-text-modal";
import "./emailNotificationRow.css";

import { updateEmailNotification } from "../../../../actions";
import { updateFailedSelector } from "../../../../selectors";

const EmailNotificationRow = ({ entry }) => {
  const dispatch = useDispatch();

  const [isOpenDetails, setIsOpenDetails] = useState(false);
  const failed = useSelector(updateFailedSelector);

  const [recipients, setRecipients] = useState(entry.recipients);
  const [isActive, setIsActive] = useState(entry.isActive);
  const [fullText, setFullText] = useState(entry.fullText);
  const [subject, setSubject] = useState(entry.subject);

  const toggleDetails = () => {
    setIsOpenDetails(!isOpenDetails);
  };
  useEffect(() => {
    setRecipients(entry.recipients);
    setIsActive(entry.isActive);
    setFullText(entry.fullText);
    setSubject(entry.subject);
  }, [failed]);

  const changeRecipientsValue = (data) => {
    setRecipients(data.target.value);
  };
  const changeEmailNotificationActive = () => {
    setIsActive(!isActive);
  };
  const changeText = (data) => {
    setFullText(data.target.value);
  };

  const changeSubject = (data) => {
    setSubject(data.target.value);
  };

  const saveRow = () => {
    // debugger;
    toggleDetails();
    dispatch(
      updateEmailNotification({
        subject,
        fullText,
        recipients,
        isActive,
        type: entry.type,
      })
    );
  };

  return (
    <React.Fragment>
      <tr>
        <td>
          <div
            className="email-notifications-details-clickable"
            onClick={toggleDetails}
          >
            {entry.name}
          </div>
        </td>
        <td>{entry.description}</td>
        <td>
          <div class="cont">{entry.recipients}</div>
        </td>
        <td className="center">
          {entry.isActive ? (
            <FaCheck color="#0AD172" />
          ) : (
            <ImCross color="#FF0000" />
          )}
        </td>

        <EmailNotificationTextModal
          toggle={toggleDetails}
          handleSave={saveRow}
          recipients={recipients}
          subject={subject}
          fullText={fullText}
          isOpen={isOpenDetails}
          changeText={changeText}
          changeSubject={changeSubject}
          changeRecipientsValue={changeRecipientsValue}
          isActive={isActive}
          placeholders={entry.placeholders}
          changeEmailNotificationActive={changeEmailNotificationActive}
        />
      </tr>
    </React.Fragment>
  );
};

export default EmailNotificationRow;



// WEBPACK FOOTER //
// ./src/features/organization/pages/email-notifications/email-notifications-table/row/EmailNotificationRow.jsx